import { AlpineComponent } from '@alpinejs/csp';

const StandardTeaser = (): AlpineComponent => ({
  visible: false,
  handleIntersect() {
    this.visible = true;
  },
  getClassName() {
    return this.visible ? 'standard-teaser--visible' : '';
  }
});

export default StandardTeaser;
